import { ComponentPropsWithoutRef } from 'react'

import { Box, Theme, withStyles } from '@material-ui/core'
//@ts-expect-error untyped library
import { EventDetailsSection } from '@scoir/react-calendar'

export const Section = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(0, 2),
  },
}))(({ classes, ...rest }: ComponentPropsWithoutRef<typeof EventDetailsSection>) => {
  return (
    <EventDetailsSection
      {...rest}
      className={classes.root}
    />
  )
})
export const Title = (props: Pick<ComponentPropsWithoutRef<typeof Box>, 'color' | 'bgcolor' | 'children'>) => {
  return (
    <Box
      {...props}
      mb={2}
      py={2}
      px={2}
    />
  )
}
